var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 45,
    viewBox: "0 0 31 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bookmark (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bookmark_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.008 44.8114L15.5018 37.3082L2.99553 44.8114C2.58869 45.056 2.08148 45.0637 1.66945 44.8281C1.25488 44.5938 1 44.1561 1 43.681V1.31834C1 0.58965 1.58965 0 2.31834 0H28.6852C29.4139 0 30.0035 0.58965 30.0035 1.31834V43.681C30.0035 44.1561 29.7486 44.5939 29.3341 44.8282C28.9258 45.0611 28.4185 45.0572 28.008 44.8114Z",
    fill: "url(#paint0_linear_246_1472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.5393 32.7907L15.5018 30.6689L11.4643 32.7907C11.0215 33.0224 10.4833 32.9876 10.0765 32.6902C9.66963 32.3954 9.46625 31.8959 9.55115 31.4015L10.3236 26.907L7.0587 23.7231C6.69817 23.373 6.5695 22.849 6.72392 22.3713C6.87843 21.8949 7.29301 21.5473 7.78739 21.4753L12.3011 20.82L14.3199 16.7311C14.7627 15.8299 16.2407 15.8299 16.6836 16.7311L18.7024 20.82L23.2161 21.4753C23.7105 21.5473 24.1251 21.8949 24.2796 22.3713C24.4341 22.849 24.3053 23.3729 23.9448 23.7231L20.6799 26.907L21.4523 31.4015C21.5373 31.8959 21.3339 32.3954 20.927 32.6902C20.5352 32.9765 19.9977 33.0321 19.5393 32.7907Z",
    fill: "url(#paint1_linear_246_1472)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_246_1472",
    x1: 15.5018,
    y1: 45,
    x2: 15.5018,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_246_1472",
    x1: 15.5018,
    y1: 32.9426,
    x2: 15.5018,
    y2: 16.0552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFD5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.0dc0bf5fefae2575312b29be8115f844.svg";
export { ForwardRef as ReactComponent };